var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/ExploreMenu.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useContext } from 'react';
import { IconCaretDown } from '@wds/icons';
import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { Accordion } from '@wds/accordion';
import { List } from '@wds/list';
import HeaderContext from '../../HeaderContext';
import { NavButton } from '../nav-button';
import MenuItems from '../info-menu/MenuItems';
import ExplorePanel from './ExplorePanel';
var ExploreMenu = function ExploreMenu() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var trackMenuEvents = function trackMenuEvents(opened) {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked menu',
        menuName: 'explore',
        opened: opened
      }
    });
  };
  var onToggle = function onToggle() {
    trackMenuEvents(!show);
    setShow(!show);
  };
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement("div", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(NavButton, {
      label: "Open explore menu",
      onClick: onToggle,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 13
      }
    }, "Explore", /*#__PURE__*/React.createElement(Box, {
      ml: 2,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(IconCaretDown, {
      title: "Dropdown arrow icon",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 17
      }
    }))), /*#__PURE__*/React.createElement(ExplorePanel, {
      show: show,
      onToggle: onToggle,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 13
      }
    })) : /*#__PURE__*/React.createElement(Accordion, {
      key: "accordion-Explore",
      noRules: true,
      interactive: true,
      onChange: function onChange(e) {
        return trackMenuEvents(!e.length);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Accordion.Item, {
      title: "Explore",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(List, {
      noRules: true,
      interactive: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(MenuItems, {
      title: "Audience",
      url: "https://www.surveymonkey.com/collect/audience/calculator/preview?ut_source=header&ut_source3=buy_targeted_responses",
      navItem: "audience",
      subTitle: "",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(MenuItems, {
      title: " Brand and market research",
      url: "https://www.surveymonkey.com/market-research/solutions/get-started/?ut_source=header",
      navItem: " Brand and market research",
      subTitle: "",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 17
      }
    }))));
  });
};

// eslint-disable-next-line import/prefer-default-export
export { ExploreMenu };
//# sourceMappingURL=ExploreMenu.js.map